import { type NoteEditorVariant } from '@/models/analytics/features/notes';
import { type LogContext } from '@heidi/runtime/logger';

/**
 * Process-local store for the routed editor variant. `setDatadogEditorContext`
 * writes it; logger `enrich` and tests read it. Kept out of `tracing.ts` so
 * `runtime-wiring` can enrich log records without importing the Datadog SDK.
 */
let currentEditorVariant: NoteEditorVariant | null = null;

export function getDatadogEditorVariant(): NoteEditorVariant | null {
  return currentEditorVariant;
}

export function setDatadogEditorVariantStore(variant: NoteEditorVariant | null): void {
  currentEditorVariant = variant;
}

/**
 * Ambient logger enricher: stamps `editor_variant` when a note/document pane
 * has set one. Omitted (not null) when unset so an unstamped record is
 * distinguishable from a pane that routed an editor.
 */
export function editorVariantLogEnrich(): LogContext {
  const editor_variant = getDatadogEditorVariant();
  return editor_variant === null ? {} : { editor_variant };
}

/** Test-only: drop the stored variant between cases. */
export function __resetDatadogEditorVariantStoreForTests(): void {
  currentEditorVariant = null;
}
